import { reatomBoolean } from '@reatom/framework'
import { withLocalStorage } from '@reatom/persist-web-storage'

import { STORAGE_PREFIX } from '@root/shared'

const STORAGE_KEY = `${STORAGE_PREFIX}/v1/showShortcutsHints`

export const showShortcutsHintsAtom = reatomBoolean(
  true,
  'showShortcutsHintsAtom',
).pipe(withLocalStorage(STORAGE_KEY))
